import type { Release } from '../releases.ts';

export default {
  version: '0.99.0',
  date: '2026-10-10',
  title: 'Export in the original format',
  summary: [
    'Export in the original format, copied byte for byte without a transcode',
    'A marked range is rewrapped without a transcode, cut frame-accurately for intra-only formats',
    'Long-GOP originals are cut at keyframes, never shorter than what was marked',
    'Every asset with media can now be exported, including images and graphics',
    'Export downloads use the file’s real extension',
  ],
  features: [
    'Export has a new format, “Original format · no transcode”, first in the Format list. The whole asset is the original file, copied byte for byte (checked against its checksum), to the exports tier, an export location or a folder on a storage agent',
    'A programme or marked range of video or audio in the original format is rewrapped into the same container without a transcode. ProRes, DNxHD/HR, AVC-Intra and other intra-only originals are cut frame-accurately, and audio to the sample',
    'Long-GOP originals (H.264, HEVC, XDCAM) are cut at keyframes: the start moves to the keyframe at or before In and the end to the keyframe at or after Out, so the clip is never shorter than what was marked. The export list shows the real range, for example “Rewrap 01:00:02:00–01:00:05:01 (widened +0.32 s / +0.56 s)”',
    'The rewrapped file’s timecode starts at the source timecode plus its real In, and sidecar subtitles move with a widened start',
    'Every asset with media now has Export: images, graphics, audio and other files are exported in their original format, and images, graphics and other files always whole',
    'With Original format, Source is hidden (it is the original) and burning subtitles in is disabled, since it needs a transcode; sidecar files still work',
    'Export downloads use the file’s real extension (MOV, MXF, WAV, PNG…)',
  ],
  fixes: [],
} satisfies Release;
